import store from '@/store';
import {
  Action,
  Module,
  Mutation,
  VuexModule,
  getModule
} from 'vuex-module-decorators';
import {
  applyAiDisclaimer,
  applyDisclaimer,
  getDisclaimerTarget,
  getShortUrlTarget,
  isDirectDisclaimer,
  isDirectDisclaimerForGuid
} from '../api';
import { AiDisclaimerRequestDto, ShortUrlEntity, ShortUrlRequest } from '../models';

@Module({
  dynamic: true,
  namespaced: true,
  name: 'ShortUrlModule',
  store
})
class ShortUrlModule extends VuexModule {
  public shortUrlEntity: ShortUrlEntity | null = null;

  @Mutation
  public setShortUrlResult(shortUrlResult: ShortUrlEntity | null) {
    this.shortUrlEntity = shortUrlResult;
  }

  @Action({ commit: 'setShortUrlResult', rawError: true })
  public async doGetShortUrlTarget(request: ShortUrlRequest) {
    try {
      const response = await getShortUrlTarget(request);
      return response;
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ rawError: true })
  public async doIsDirectDisclaimerForGuid(guid: string) {
    try {
      return await isDirectDisclaimerForGuid(guid);
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ rawError: true })
  public async doIsDirectDisclaimer() {
    try {
      return await isDirectDisclaimer();
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ rawError: true })
  public async doGetDisclaimerTarget(request: ShortUrlRequest) {
    try {
      const response = await getDisclaimerTarget(request);
      return response;
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ rawError: true })
  public async doApplyDisclaimer(request: ShortUrlRequest) {
    try {
      const response = await applyDisclaimer(request);
      return response;
    } catch (error) {
      throw new Error(error as string);
    }
  }

  @Action({ rawError: true })
  public async doApplyAiDisclaimer(request: AiDisclaimerRequestDto) {
    try {
      const response = await applyAiDisclaimer(request);
      return response;
    } catch (error) {
      throw new Error(error as string);
    }
  }

}

export default getModule(ShortUrlModule);
